export default class SuggestError extends Error {
  constructor() {
    super('Pas de suggestion correspondant à cette recherche.')
    this.name = 'SuggestError'
  }
}
